import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import AlertEmailsList from "./ListAlertEmails/AlertEmailsList";
import AddEmails from "./AddAlertEmails/AddEmails";
import { IEmail } from "../../../interfaces/IEmailAlerts";

const AlertEmails: React.FC = () => {
	const [selectedTab, setSelectedTab] = useState<string>("email");
	const [selectedEmail, setSelectedEmail] = useState<IEmail | null>(null);

	const handleEdit = (email: IEmail) => {
		setSelectedEmail(email); // Store the selected email
		setSelectedTab("add"); // Switch tab
	};

	useEffect(() => {
		if (selectedTab === "add") return;
		setSelectedEmail(null);
	}, [selectedTab]);

	return (
		<>
			<div className="page-title">
				<p>Email Alerts</p>
				<p className="page-subtitle">
					Add the email addresses you'd like to be notified at whenever an issue
					arises, so you can stay informed and respond quickly.
				</p>
			</div>
			<div className="container-fluid mt-2">
				<div>
					<ul className="nav nav-tabs" id="myTab" role="tablist">
						<li className="nav-item" role="presentation" onClick={() => setSelectedTab("email")}>
							<a
								className={selectedTab === "email" ? "nav-link active" : "nav-link"}
								id="email-tab"
								data-bs-toggle="tab"
								role="tab"
								aria-controls="email"
								aria-selected={selectedTab === "email"}
							>
								Email Addresses
							</a>
						</li>
						<li className="nav-item" role="presentation" onClick={() => setSelectedTab("add")}>
							<a
								className={selectedTab === "add" ? "nav-link active" : "nav-link"}
								id="add-tab"
								data-bs-toggle="tab"
								role="tab"
								aria-controls="add"
								aria-selected={selectedTab === "add"}
							>
								Add
							</a>
						</li>
					</ul>
				</div>
			</div>

			{selectedTab === "email" ? (
				<AlertEmailsList onEdit={handleEdit} />
			) : (
				<AddEmails email={selectedEmail} />
			)}

			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
			/>
		</>
	);
};

export default AlertEmails;
